import React from 'react';
import BaseChart from './BaseChart';
import { ChartOptions, ChartType } from './BaseChart';

interface MonthlyRevenueChartProps {
  data: {
    labels: string[];
    values: number[];
  };
  title?: string;
  type?: ChartType;
  options?: ChartOptions;
}

const MonthlyRevenueChart: React.FC<MonthlyRevenueChartProps> = ({
  data,
  title = 'Monthly Revenue',
  type = 'bar',
  options = {},
}) => {
  const chartData = {
    labels: data.labels,
    datasets: [
      {
        label: 'Revenue',
        data: data.values,
        backgroundColor: 'rgba(54, 162, 235, 0.2)',
        borderColor: 'rgba(54, 162, 235, 1)',
        borderWidth: 1,
      },
    ],
  };

  return (
    <BaseChart
      type={type}
      data={chartData}
      title={title}
      height={300}
      width={800}
      options={options}
    />
  );
};

export default MonthlyRevenueChart; 